/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

import React from 'react';

const EmptyImage = () => {
	return (
		<svg
			width="160"
			height="160"
			viewBox="0 0 570 372"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_1375_254)">
				<rect
					width="569.18"
					height="371.12"
					transform="translate(0 0.380859)"
					fill="white"
					fillOpacity="0.01"
				/>
				<path
					opacity="0.1"
					d="M240.23 361.701C259.267 361.701 274.7 359.185 274.7 356.081C274.7 352.977 259.267 350.461 240.23 350.461C221.193 350.461 205.76 352.977 205.76 356.081C205.76 359.185 221.193 361.701 240.23 361.701Z"
					fill="#344563"
				/>
				<path
					opacity="0.1"
					d="M42.5 363.901C64.6024 363.901 82.52 360.982 82.52 357.381C82.52 353.78 64.6024 350.861 42.5 350.861C20.3975 350.861 2.47998 353.78 2.47998 357.381C2.47998 360.982 20.3975 363.901 42.5 363.901Z"
					fill="#344563"
				/>
				<path
					opacity="0.1"
					d="M405.28 371.5C430.978 371.5 451.81 368.102 451.81 363.91C451.81 359.718 430.978 356.32 405.28 356.32C379.582 356.32 358.75 359.718 358.75 363.91C358.75 368.102 379.582 371.5 405.28 371.5Z"
					fill="#344563"
				/>
				<path
					opacity="0.05"
					d="M565.31 314.73H215.2L51.6201 341.01H494.75L565.88 322.44C568 322.12 569.45 320.14 569.13 318.02C568.85 316.13 567.22 314.73 565.31 314.73Z"
					fill="#344563"
				/>
				<path
					d="M224.39 319.611H530.37C532.75 319.741 534.78 317.921 534.91 315.541C534.94 314.991 534.87 314.451 534.69 313.931L443.41 28.4813C442.58 26.1213 440.35 24.5513 437.85 24.5313H131.88C129.5 24.3713 127.45 26.1813 127.3 28.5513C127.26 29.1113 127.34 29.6713 127.52 30.2113L218.84 315.651C219.66 318.021 221.89 319.601 224.39 319.611Z"
					fill="url(#paint0_linear_1375_254)"
				/>
				<path
					d="M183.61 341.011H489.58C492.43 341.031 494.75 338.731 494.76 335.881C494.76 335.561 494.73 335.241 494.68 334.931L438.8 28.7711C438.35 26.3211 436.22 24.5311 433.72 24.5411H127.74C124.89 24.5411 122.58 26.8411 122.58 29.6911C122.58 30.0111 122.61 30.3211 122.67 30.6311L178.53 336.781C178.97 339.241 181.12 341.021 183.61 341.011Z"
					fill="#C1C7D0"
				/>
				<path
					d="M445.66 341.011H139.53C136.8 341.021 134.54 338.891 134.37 336.161L115.76 30.021C115.58 27.181 117.74 24.731 120.58 24.551C120.69 24.541 120.8 24.541 120.91 24.541H427.04C429.77 24.541 432.03 26.661 432.2 29.391L450.82 335.541C451 338.381 448.84 340.831 446 341.011C445.88 341.011 445.77 341.011 445.66 341.011Z"
					fill="url(#paint1_linear_1375_254)"
				/>
				<path
					d="M401.67 341.011H95.5299C92.6799 341.021 90.3699 338.711 90.3599 335.861C90.3599 335.751 90.3599 335.641 90.3699 335.531L109.01 29.3813C109.17 26.6513 111.44 24.5313 114.17 24.5313H420.29C423.14 24.5213 425.45 26.8313 425.46 29.6813C425.46 29.7913 425.46 29.9013 425.45 30.0113L406.82 336.151C406.66 338.881 404.4 341.011 401.67 341.011Z"
					fill="url(#paint2_linear_1375_254)"
				/>
				<path
					d="M357.59 341.011H51.62C48.77 341.011 46.46 338.711 46.46 335.861C46.46 335.551 46.49 335.241 46.54 334.931L102.35 28.7711C102.8 26.3211 104.93 24.5311 107.43 24.5411H413.46C416.31 24.5411 418.62 26.8411 418.62 29.6911C418.62 30.0111 418.59 30.3211 418.53 30.6311L362.67 336.781C362.22 339.231 360.08 341.011 357.59 341.011Z"
					fill="url(#paint3_linear_1375_254)"
				/>
				<path
					d="M418.53 30.6318C419 28.1818 417.65 25.7418 415.32 24.8418L118.47 33.9818C115.97 33.9918 113.75 35.5718 112.91 37.9318L84.5599 126.532L47.6099 329.052H331.94C334.44 329.042 336.66 327.462 337.5 325.102L414.67 51.9518L418.53 30.6318Z"
					fill="url(#paint4_linear_1375_254)"
				/>
				<path
					d="M313.05 319.611H7.07008C4.69007 319.771 2.64008 317.961 2.49008 315.591C2.45008 315.031 2.53008 314.471 2.71008 313.931L94.0201 28.4813C94.8501 26.1213 97.0801 24.5513 99.5801 24.5313H405.57C407.95 24.3713 410 26.1813 410.15 28.5513C410.19 29.1113 410.11 29.6713 409.93 30.2113L318.61 315.651C317.79 318.021 315.56 319.601 313.05 319.611Z"
					fill="url(#paint5_linear_1375_254)"
				/>
				<path
					d="M405.57 24.5413H99.5898C97.0898 24.5513 94.8698 26.1313 94.0298 28.4913L80.5298 70.7313H396.99L409.94 30.2513C410.71 28.0013 409.51 25.5413 407.26 24.7713C406.72 24.5813 406.14 24.5013 405.57 24.5413Z"
					fill="#FF7143"
				/>
				<path
					d="M342.41 54.8809C346.828 54.8809 350.41 51.2991 350.41 46.8809C350.41 42.4626 346.828 38.8809 342.41 38.8809C337.992 38.8809 334.41 42.4626 334.41 46.8809C334.41 51.2991 337.992 54.8809 342.41 54.8809Z"
					fill="#0065FF"
				/>
				<path
					d="M366.55 24.5309H362.96C362.96 13.2009 353.74 3.97086 342.4 3.97086C331.06 3.97086 321.84 13.1909 321.84 24.5309H318.25C318.26 11.2109 329.09 0.380859 342.41 0.380859C355.73 0.380859 366.55 11.2109 366.55 24.5309Z"
					fill="#EBECF0"
				/>
				<path
					d="M342.42 48.6715C329.11 48.6715 318.27 37.8415 318.27 24.5215H321.86C321.86 35.8515 331.08 45.0815 342.42 45.0815V48.6715Z"
					fill="url(#paint6_linear_1375_254)"
				/>
				<path
					d="M240.79 54.8809C245.208 54.8809 248.79 51.2991 248.79 46.8809C248.79 42.4626 245.208 38.8809 240.79 38.8809C236.372 38.8809 232.79 42.4626 232.79 46.8809C232.79 51.2991 236.372 54.8809 240.79 54.8809Z"
					fill="#0065FF"
				/>
				<path
					d="M264.94 24.5309H261.35C261.35 13.2009 252.13 3.97086 240.79 3.97086C229.46 3.97086 220.23 13.1909 220.23 24.5309H216.64C216.65 11.2109 227.48 0.380859 240.8 0.380859C254.11 0.380859 264.94 11.2109 264.94 24.5309Z"
					fill="#EBECF0"
				/>
				<path
					d="M240.79 48.6715C227.48 48.6715 216.64 37.8415 216.64 24.5215H220.23C220.23 35.8515 229.45 45.0815 240.79 45.0815V48.6715Z"
					fill="url(#paint7_linear_1375_254)"
				/>
				<path
					d="M139.18 54.8809C143.598 54.8809 147.18 51.2991 147.18 46.8809C147.18 42.4626 143.598 38.8809 139.18 38.8809C134.762 38.8809 131.18 42.4626 131.18 46.8809C131.18 51.2991 134.762 54.8809 139.18 54.8809Z"
					fill="#0065FF"
				/>
				<path
					d="M163.29 24.5309H159.7C159.7 13.2009 150.48 3.97086 139.14 3.97086C127.8 3.97086 118.58 13.1909 118.58 24.5309H115C115 11.2109 125.83 0.380859 139.14 0.380859C152.45 0.380859 163.29 11.2109 163.29 24.5309Z"
					fill="#EBECF0"
				/>
				<path
					d="M139.14 48.6715C132.7 48.6715 126.65 46.1715 122.09 41.6215C117.52 37.0715 115 31.0115 114.99 24.5615L118.58 24.5215C118.59 30.0415 120.73 35.2015 124.62 39.0815C128.5 42.9515 133.65 45.0815 139.13 45.0815C139.14 45.0815 139.15 45.0815 139.16 45.0815L139.17 48.6715C139.17 48.6715 139.16 48.6715 139.14 48.6715Z"
					fill="url(#paint8_linear_1375_254)"
				/>
				<path
					d="M342.7 135.791L343.64 132.871H292.26L305.23 92.5215H302.31L289.34 132.871H251.67L264.62 92.5215H261.7L248.73 132.871H211.1L224.07 92.5215H221.15L208.17 132.871H170.5L183.48 92.5215H180.56L167.59 132.871H129.91L142.88 92.5215H139.96L126.99 132.871H86.6398L85.6698 135.791H126.02L113.92 173.451H73.5898L72.6498 176.371H113L100.9 214.041H60.5398L59.5998 216.961H99.9498L87.8498 254.631H47.4898L46.5498 257.551H86.8998L73.9298 297.901H76.8498L89.8198 257.551H127.48L114.51 297.901H117.43L130.4 257.551H168.06L155.09 297.901H158.01L170.98 257.551H208.64L195.71 297.901H198.63L211.6 257.551H249.26L236.29 297.901H239.21L252.18 257.551H303.52L304.46 254.631H253.11L265.21 216.971H316.58L317.52 214.051H266.15L278.25 176.391H329.62L330.56 173.471H279.19L291.27 135.791H342.7ZM247.81 135.791L235.72 173.451H198.03L210.16 135.791H247.81ZM197.1 176.381H234.76L222.66 214.041H184.99L197.1 176.381ZM182.06 214.041H144.4L156.5 176.381H194.16L182.06 214.041ZM207.22 135.791L195.12 173.451H157.45L169.55 135.791H207.22ZM128.98 135.791H166.64L154.54 173.451H116.87L128.98 135.791ZM115.93 176.381H153.59L141.48 214.041H103.82L115.93 176.381ZM90.7598 254.631L102.86 216.971H140.52L128.42 254.631H90.7598ZM131.35 254.631L143.46 216.961H181.12L169.03 254.631H131.35ZM171.94 254.631L184.04 216.971H221.7L209.6 254.631H171.94ZM250.19 254.631H212.52L224.6 216.961H262.26L250.19 254.631ZM263.24 214.041H225.57L237.67 176.381H275.33L263.24 214.041ZM276.29 173.451H238.62L250.72 135.791H288.38L276.29 173.451Z"
					fill="url(#paint9_linear_1375_254)"
				/>
				<path
					opacity="0.7"
					d="M156.56 188.81L155.14 191.28C154.72 192.01 154.97 192.94 155.7 193.36C155.71 193.36 155.71 193.37 155.72 193.37L168.1 200.21C161.06 201.46 154.37 204.24 148.53 208.37C126.61 223.25 124.62 273.88 123.82 279.5C123.7 280.33 124.27 281.09 125.1 281.21C125.13 281.21 125.16 281.22 125.19 281.22L128.96 281.56C129.76 281.63 130.48 281.07 130.59 280.27C131.28 275.54 134.71 226.8 152.71 213.67C158.63 209.36 165.66 206.86 172.97 206.46L161.26 221.36C160.74 222.02 160.86 222.98 161.53 223.5L161.54 223.51L163.85 225.24C164.51 225.74 165.45 225.61 165.96 224.96L181.95 204.6C182.85 203.45 182.65 201.79 181.5 200.89C181.39 200.8 181.27 200.73 181.15 200.66L158.61 188.22C157.88 187.83 156.97 188.09 156.56 188.81Z"
					fill="url(#paint10_linear_1375_254)"
				/>
				<path
					opacity="0.7"
					d="M351.39 155.471L351.73 152.141C351.83 151.171 351.13 150.301 350.16 150.201C350.15 150.201 350.13 150.201 350.12 150.201L333.66 148.791C340.75 144.321 346.6 138.121 350.65 130.781C359.13 115.281 356.37 100.161 354.57 93.8415C354.3 92.9015 353.33 92.3515 352.39 92.6215C352.36 92.6315 352.32 92.6415 352.29 92.6515L348.11 94.0815C347.23 94.3915 346.75 95.3315 347 96.2315C349.93 106.581 348.74 117.671 343.67 127.161C339.49 134.641 333.16 140.681 325.49 144.491L330.91 122.961C331.15 122.011 330.58 121.051 329.63 120.811C329.62 120.811 329.6 120.801 329.59 120.801L326.26 120.041C325.32 119.821 324.38 120.401 324.15 121.331L316.86 150.671C316.45 152.331 317.46 154.001 319.11 154.411C319.26 154.451 319.42 154.471 319.58 154.491L349.48 157.101C350.45 157.181 351.31 156.461 351.39 155.491C351.39 155.481 351.39 155.471 351.39 155.471Z"
					fill="url(#paint11_linear_1375_254)"
				/>
				<path
					d="M247.51 238.051C233.19 238.111 219.65 231.541 210.83 220.271C203.26 210.661 200.49 198.111 203.31 186.201C206.56 172.261 216.9 159.391 231.7 150.891C246.08 142.631 261.8 140.231 272.72 144.631C279.28 147.281 284.48 152.481 288.17 160.101L281.97 163.681C278.9 157.341 274.69 153.051 269.47 150.951C260.5 147.341 246.76 149.571 234.47 156.631C221.62 164.011 212.67 175.021 209.93 186.851C207.58 196.971 209.98 207.611 216.44 215.751C224.12 225.591 235.91 231.331 248.39 231.311C268.27 231.311 293.34 214.061 299.15 186.271C304.21 162.071 290.04 139.591 266.17 134.031L268.55 127.441C295.52 133.751 311.53 159.251 305.78 186.751C300.62 211.401 276.88 238.021 247.46 238.051H247.51Z"
					fill="#FF8F73"
				/>
				<path
					d="M313.19 264.24L302.91 260.83C302.42 260.67 301.89 260.93 301.72 261.42L297.67 273.3C297.5 273.79 297.76 274.33 298.26 274.5L300.05 275.11C300.54 275.28 301.08 275.02 301.25 274.52L303.3 268.5L313.75 295.61C313.94 296.09 314.48 296.34 314.96 296.15L316.73 295.48C317.22 295.29 317.46 294.75 317.28 294.26L306.38 265.96L312 267.83C312.49 267.99 313.03 267.72 313.19 267.23L313.79 265.44C313.94 264.95 313.68 264.41 313.19 264.24Z"
					fill="#FF8F73"
				/>
				<path
					d="M286.6 245.93L276.99 240.95C276.53 240.71 275.96 240.89 275.72 241.35L269.86 252.46C269.62 252.92 269.79 253.49 270.26 253.74L271.93 254.62C272.39 254.86 272.96 254.69 273.21 254.22L276.18 248.58L279.51 264.4C279.62 264.91 280.11 265.24 280.62 265.13L282.47 264.74C282.98 264.63 283.31 264.14 283.2 263.63L279.64 246.56L284.9 249.28C285.36 249.52 285.93 249.35 286.18 248.88L287.05 247.2C287.28 246.73 287.09 246.17 286.63 245.93C286.62 245.93 286.61 245.93 286.6 245.93Z"
					fill="#FFC400"
				/>
				<path
					d="M311.71 222.68L300.92 223.66C300.4 223.71 300.02 224.16 300.06 224.68L301.1 237.19C301.14 237.71 301.6 238.1 302.12 238.06C302.12 238.06 302.12 238.06 302.13 238.06L304.01 237.9C304.53 237.86 304.92 237.4 304.88 236.88C304.88 236.88 304.88 236.88 304.88 236.87L304.35 230.52L315.64 242.08C316.01 242.45 316.61 242.45 316.97 242.08L318.33 240.76C318.7 240.39 318.7 239.79 318.33 239.43L306.1 226.95L312 226.42C312.52 226.37 312.9 225.92 312.86 225.4L312.69 223.52C312.63 223.02 312.21 222.66 311.71 222.68Z"
					fill="#FFC400"
				/>
				<path
					d="M178.67 181.09L186.65 173.77C187.04 173.42 187.07 172.82 186.72 172.44L178.3 163.13C177.95 162.74 177.35 162.71 176.97 163.06L175.57 164.33C175.18 164.68 175.15 165.28 175.5 165.66L179.77 170.38L163.79 168.03C163.28 167.93 162.78 168.27 162.69 168.78C162.69 168.8 162.68 168.81 162.68 168.83L162.4 170.7C162.3 171.21 162.64 171.71 163.15 171.8C163.17 171.8 163.18 171.81 163.2 171.81L180.46 174.33L176.09 178.33C175.71 178.68 175.68 179.28 176.03 179.66L177.31 181.05C177.66 181.44 178.26 181.47 178.64 181.11C178.65 181.11 178.66 181.1 178.67 181.09Z"
					fill="#FF8F73"
				/>
				<path
					d="M190.29 162.77L201.04 161.47C201.55 161.41 201.92 160.94 201.86 160.43L200.45 147.96C200.39 147.44 199.92 147.07 199.41 147.13L197.53 147.34C197.01 147.4 196.64 147.87 196.7 148.38L197.41 154.7L171.51 129.21C171.14 128.84 170.55 128.83 170.17 129.2L170.16 129.21L168.85 130.57C168.48 130.94 168.48 131.54 168.85 131.9L195.7 158.31L189.82 159.02C189.3 159.08 188.93 159.55 189 160.07L189.22 161.95C189.3 162.47 189.77 162.84 190.29 162.77Z"
					fill="#FFE380"
				/>
				<path
					d="M204.6 247.561C203.94 247.901 203.2 248.071 202.45 248.051L197.89 247.931L194.81 251.891C194.33 252.511 193.73 253.011 193.03 253.371C191.85 254.001 190.45 254.031 189.24 253.461C188.05 252.881 187.22 251.751 187.02 250.451L186.19 245.771L182 244.271C180.4 243.661 179.34 242.131 179.34 240.411C179.29 238.571 180.17 236.831 181.69 235.791L185.74 233.011L186.23 228.121C186.41 226.291 187.51 224.671 189.15 223.831C190.65 223.001 192.5 223.201 193.8 224.321L197.13 227.291L201.58 225.771C203.17 225.181 204.95 225.661 206.03 226.971C207.11 228.391 207.31 230.281 206.55 231.891L204.6 236.511L206.89 240.461C207.56 241.671 207.68 243.101 207.22 244.411C206.79 245.751 205.85 246.891 204.6 247.561Z"
					fill="url(#paint12_linear_1375_254)"
				/>
				<path
					d="M205.13 244.632C204.47 244.972 203.73 245.142 202.98 245.122L198.42 245.002L195.34 248.962C194.86 249.582 194.26 250.082 193.56 250.442C192.38 251.072 190.98 251.102 189.77 250.532C188.58 249.952 187.75 248.822 187.55 247.522L186.72 242.842L182.53 241.342C180.93 240.732 179.87 239.202 179.87 237.482C179.82 235.642 180.7 233.902 182.22 232.862L186.27 230.082L186.76 225.192C186.94 223.362 188.04 221.742 189.68 220.902C191.18 220.072 193.03 220.272 194.33 221.392L197.66 224.362L202.11 222.842C203.7 222.252 205.48 222.732 206.56 224.042C207.64 225.462 207.84 227.352 207.08 228.962L205.09 233.572L207.38 237.522C208.05 238.732 208.17 240.162 207.71 241.472C207.3 242.802 206.37 243.942 205.13 244.632Z"
					fill="white"
				/>
				<path
					d="M192.51 223.661L196.87 227.541L202.75 225.551C203.64 225.261 204.59 225.741 204.88 226.621C205.03 227.081 204.98 227.581 204.73 228.001L202.13 234.041L205.13 239.211C205.65 240.241 205.24 241.501 204.21 242.021C203.94 242.161 203.64 242.231 203.34 242.251L197.38 242.091L193.35 247.271C192.86 248.071 191.82 248.311 191.03 247.831C190.62 247.581 190.34 247.171 190.25 246.701L189.14 240.581L183.65 238.611C182.7 238.131 182.31 236.971 182.79 236.011C182.96 235.681 183.21 235.401 183.53 235.221L188.82 231.591L189.46 225.201C189.48 224.141 190.36 223.291 191.42 223.321C191.81 223.311 192.19 223.441 192.51 223.661Z"
					fill="#FFAB00"
				/>
				<path
					d="M315.54 196.7C314.87 196.37 314.3 195.89 313.86 195.29L311.21 191.56L306.2 191.48C305.43 191.47 304.67 191.28 303.98 190.95C302.78 190.38 301.91 189.29 301.63 187.98C301.4 186.68 301.82 185.36 302.74 184.42L305.99 180.94L304.62 176.69C304.14 175.04 304.73 173.27 306.1 172.24C307.54 171.09 309.47 170.75 311.21 171.34L315.86 172.9L320.06 170.35C321.63 169.4 323.58 169.31 325.24 170.11C326.8 170.81 327.76 172.41 327.64 174.11L327.27 178.56L331.18 181.24C332.61 182.15 333.3 183.87 332.9 185.52C332.4 187.22 331.01 188.5 329.28 188.85L324.4 190.04L322.62 194.24C322.06 195.5 320.99 196.46 319.67 196.87C318.34 197.37 316.85 197.31 315.54 196.7Z"
					fill="url(#paint13_linear_1375_254)"
				/>
				<path
					d="M318.21 195.37C317.54 195.04 316.97 194.56 316.53 193.96L313.88 190.25L308.87 190.17C308.1 190.16 307.34 189.97 306.65 189.64C305.45 189.07 304.58 187.98 304.3 186.67C304.07 185.37 304.49 184.05 305.41 183.11L308.66 179.63L307.34 175.37C306.86 173.72 307.45 171.95 308.82 170.92C310.26 169.77 312.19 169.43 313.93 170.02L318.58 171.58L322.78 169.03C324.35 168.08 326.3 167.99 327.96 168.79C329.52 169.49 330.48 171.09 330.36 172.79L329.99 177.24L333.9 179.92C335.33 180.83 336.02 182.55 335.62 184.2C335.12 185.9 333.73 187.18 332 187.53L327.12 188.72L325.34 192.92C324.78 194.18 323.71 195.14 322.39 195.55C321.03 196.06 319.53 195.99 318.21 195.37Z"
					fill="white"
				/>
				<path
					d="M327.36 172.661L326.88 178.471L332 181.971C332.77 182.501 332.96 183.551 332.43 184.321C332.16 184.721 331.72 184.981 331.24 185.041L324.86 186.601L322.54 192.161C322.03 193.201 320.78 193.621 319.74 193.111C319.47 192.981 319.23 192.781 319.04 192.551L315.57 187.691L309.01 187.591C308.08 187.681 307.25 187.001 307.16 186.081C307.11 185.601 307.27 185.131 307.6 184.771L311.85 180.211L310.12 174.651C309.69 173.271 311.23 172.001 312.75 172.521L318.83 174.551L324.32 171.221C325.19 170.601 326.39 170.811 327 171.671C327.21 171.961 327.33 172.301 327.36 172.661Z"
					fill="#2684FF"
				/>
				<path
					d="M112.53 285.072L113.53 286.562L120.87 281.632L119.51 279.612C117.2 276.172 116.17 272.042 116.6 267.922V267.412C117.03 263.292 116 259.152 113.69 255.722L24.7698 123.452C20.5998 117.252 12.1898 115.602 5.98978 119.772C-0.210216 123.942 -1.86022 132.352 2.30978 138.552L90.9098 270.282C93.4398 274.042 97.3098 276.682 101.72 277.672C106.14 278.672 110 281.312 112.53 285.072Z"
					fill="#4C9AFF"
				/>
				<path
					d="M57.6101 220.731C57.7501 213.441 58.5101 203.721 59.0901 196.281C59.6901 188.501 60.2001 181.961 60.4301 176.421L53.5201 166.141C53.5901 174.611 52.6201 187.081 51.9401 195.731C51.5001 201.431 51.1301 206.401 50.8301 210.721L57.6101 220.731Z"
					fill="#2684FF"
				/>
				<path
					d="M27.8801 128.021C26.3801 167.341 29.8501 176.401 35.8701 177.581C41.2601 178.621 45.0301 172.221 49.0101 165.451C49.5501 164.531 50.2201 163.391 50.9101 162.281L46.5601 155.821C45.3301 157.581 44.1001 159.641 42.8301 161.821C41.3901 164.271 38.8801 168.541 37.2701 170.071C36.2601 168.091 34.3901 161.281 34.7601 138.281L27.8801 128.021Z"
					fill="#2684FF"
				/>
				<path
					d="M72.8799 194.891C66.6999 210.651 62.5999 219.341 59.9399 224.181L64.3899 230.741C67.5899 225.741 71.7999 217.001 77.7299 202.121L72.8799 194.891Z"
					fill="#2684FF"
				/>
				<path
					d="M120.74 291.591L122.96 288.361C123.27 287.911 123.27 287.321 122.96 286.871L119.88 282.291L114.65 285.811L118.53 291.581C118.93 292.191 119.75 292.371 120.36 291.971C120.51 291.871 120.64 291.741 120.74 291.591Z"
					fill="#0065FF"
				/>
				<path
					d="M326.27 234.901L324.9 236.011L330.31 242.771L332.17 241.281C335.33 238.751 339.29 237.401 343.34 237.481H343.84C347.89 237.561 351.85 236.211 355.01 233.681L476.74 136.141C482.45 131.571 483.37 123.231 478.8 117.521C478.8 117.521 478.8 117.521 478.8 117.511C474.23 111.801 465.89 110.881 460.18 115.451C460.18 115.451 460.18 115.451 460.17 115.451L338.93 212.671C335.48 215.431 333.21 219.411 332.59 223.781C331.98 228.161 329.72 232.141 326.27 234.901Z"
					fill="#FFAB00"
				/>
				<path
					d="M384.55 176.081C391.67 175.621 401.22 175.561 408.55 175.511C416.16 175.511 422.61 175.391 428.03 175.201L437.5 167.611C429.24 168.371 416.99 168.441 408.5 168.501C402.94 168.501 398.02 168.581 393.78 168.681L384.55 176.081Z"
					fill="#FFC400"
				/>
				<path
					d="M472.57 139.521C434.08 141.281 425.52 145.411 424.88 151.381C424.3 156.731 430.85 159.871 437.78 163.211C438.72 163.671 439.88 164.221 441.03 164.801L446.98 160.031C445.16 158.921 443.05 157.941 440.82 156.871C438.31 155.671 433.94 153.541 432.32 152.141C434.18 151.031 440.67 148.611 463.13 147.081L472.57 139.521Z"
					fill="#FFC400"
				/>
				<path
					d="M410.97 188.88C395.09 184.13 386.25 180.86 381.34 178.65L375.3 183.48C380.45 186.19 389.32 189.58 404.32 194.18L410.97 188.88Z"
					fill="#FFC400"
				/>
				<path
					d="M320.6 243.481L323.93 245.411C324.39 245.681 324.97 245.631 325.39 245.301L329.61 241.971L325.74 237.121L320.43 241.381C319.88 241.841 319.81 242.651 320.26 243.201C320.36 243.311 320.47 243.411 320.6 243.481Z"
					fill="#FF991F"
				/>
				<path
					d="M298.17 124.08C297.81 123.51 297.37 123 296.85 122.57C298.21 121.99 299.24 120.82 299.65 119.4L304.63 102.22C305.58 98.98 303.71 95.59 300.47 94.64C297.23 93.69 293.84 95.56 292.89 98.8C292.81 99.07 292.75 99.34 292.71 99.61L290.02 117.29C289.8 118.75 290.25 120.24 291.24 121.34C288.97 121.97 287.24 123.81 286.74 126.11C285.99 129.49 288.11 132.83 291.49 133.59L292.07 133.69C295.51 134.14 298.67 131.72 299.13 128.27C299.32 126.81 299 125.33 298.21 124.08H298.17Z"
					fill="url(#paint14_linear_1375_254)"
				/>
				<path
					d="M314.51 124.6C314.29 123.96 313.96 123.37 313.55 122.83C315.01 122.56 316.27 121.66 316.98 120.36L325.64 104.71C327.33 101.79 326.32 98.0504 323.4 96.3604C320.48 94.6704 316.74 95.6804 315.05 98.6004C314.88 98.8904 314.74 99.1904 314.63 99.5004L308.06 116.17C307.52 117.55 307.62 119.1 308.35 120.39C306 120.5 303.89 121.9 302.89 124.04C301.41 127.16 302.73 130.9 305.85 132.39L306.39 132.61C309.65 133.82 313.27 132.16 314.48 128.91C314.99 127.53 315.01 126.01 314.52 124.62L314.51 124.6Z"
					fill="url(#paint15_linear_1375_254)"
				/>
				<path
					d="M45.9098 196.31C46.0098 197.02 45.9098 197.73 45.6298 198.39C45.1698 199.5 43.7298 202.84 42.6198 202.64C42.0898 202.52 41.8498 201.6 41.8098 201.14C41.7198 200.23 42.8498 199.68 42.9198 198.72C42.9098 198.52 42.9398 198.33 43.0098 198.14C43.1098 197.56 43.1498 197.25 43.2898 197.22C43.4198 197.19 43.7998 197.8 44.1998 197.79C44.8898 197.79 45.2198 195.57 45.5998 195.64C45.7898 195.59 45.8698 196.12 45.9098 196.31Z"
					fill="#8C715D"
				/>
				<path
					d="M39.4498 203.081C40.3498 203.921 42.6198 203.481 43.7198 202.141C44.3498 201.291 44.6098 200.211 44.4398 199.161C44.2998 198.051 43.8198 197.951 43.4498 196.811C42.6698 194.391 43.8398 192.361 43.2598 192.051C43.1198 191.991 42.8598 192.051 42.3398 192.511C42.2398 192.381 42.0898 192.311 41.9298 192.301C41.5598 192.301 41.3498 192.971 41.2498 193.271C40.5698 195.081 39.9998 196.941 39.5598 198.831C39.1298 201.391 38.9898 202.671 39.4498 203.081Z"
					fill="#8C715D"
				/>
				<path
					d="M39.6299 195.381C39.4299 196.171 39.3699 196.991 39.4699 197.801C39.4699 200.761 39.0799 202.651 39.3099 202.651C39.5399 202.651 39.6499 202.071 39.7699 201.741C40.6799 199.071 42.0899 193.451 41.2699 193.181C40.8499 193.031 39.9899 194.241 39.6299 195.381Z"
					fill="#8C715D"
				/>
				<path
					d="M30.2501 356.641L18.1401 354.061L19.7801 346.391L23.5001 348.271C23.5001 349.621 24.0101 350.921 24.9401 351.901C26.4701 353.381 28.5701 352.941 29.6701 354.591C30.0701 355.201 30.2701 355.921 30.2501 356.641Z"
					fill="#162B4C"
				/>
				<path
					d="M17.878 353.132L17.7021 353.953L30.2376 356.638L30.4134 355.816L17.878 353.132Z"
					fill="#8893A5"
				/>
				<path
					d="M82.3399 355.651H68.6499V346.941L73.0999 347.131C73.5599 350.001 74.6599 351.181 75.5199 351.711C77.4399 352.921 79.6999 351.941 81.2999 353.531C81.8499 354.111 82.2199 354.851 82.3399 355.651Z"
					fill="#162B4C"
				/>
				<path d="M82.6299 354.721H68.3799V355.651H82.6299V354.721Z" fill="#8893A5" />
				<path
					d="M55.7599 249.97C54.5299 249.02 53.5999 247.72 53.0999 246.25C51.6999 242.08 53.9499 237.56 58.1199 236.16C60.4799 235.37 63.0799 235.72 65.1399 237.13C66.5099 236.52 68.1199 237.13 68.7399 238.51C69.2099 239.56 68.9699 240.78 68.1399 241.58C68.1399 241.84 68.0999 242.11 68.0199 242.36C67.3199 245.15 65.5999 247.59 63.2099 249.18L55.7599 249.97Z"
					fill="#27375C"
				/>
				<path
					d="M60.7102 257.44C58.0602 258.37 55.1102 257.86 52.9302 256.08C54.6602 253.97 55.6902 251.38 55.8802 248.66L62.3702 249.77L60.7102 257.44Z"
					fill="#8C715D"
				/>
				<path
					d="M68.1499 241.572C68.1199 242.532 68.1599 243.492 68.2699 244.442C68.3499 245.082 68.4399 245.552 68.4599 245.662C68.6699 246.772 68.9999 247.852 69.4399 248.892L67.8399 249.132L66.3399 254.122C64.1899 254.582 61.9699 254.602 59.8199 254.202C57.9999 253.842 56.1399 253.492 55.3699 252.082C55.1399 251.582 54.9699 251.052 54.8699 250.512C54.7799 250.182 54.6799 249.862 54.5599 249.542C54.4299 249.142 54.2199 248.582 53.9399 247.912C54.5599 248.282 55.2599 248.492 55.9699 248.532C56.6599 248.672 57.3799 248.522 57.9599 248.132C58.7599 247.372 58.1899 246.042 58.9199 245.682C59.2399 245.552 59.6199 245.592 59.8999 245.802C60.6899 246.402 60.3199 248.382 60.3199 248.382H61.7499C61.8399 247.492 62.1499 246.632 62.6499 245.882C63.4299 244.772 64.1299 244.772 64.6999 243.662C65.2699 242.552 64.8899 241.902 65.4299 241.442C65.9699 240.982 66.4999 240.932 68.1499 241.572Z"
					fill="#8C715D"
				/>
				<path
					d="M86.2702 228.741C86.2202 229.411 86.3602 230.071 86.6702 230.661C87.1802 231.641 88.7402 234.721 89.7702 234.421C90.2602 234.281 90.4102 233.401 90.4302 232.961C90.4302 232.101 89.3202 231.671 89.2202 230.741C89.2002 230.561 89.1702 230.381 89.1102 230.211C88.9802 229.671 88.9202 229.401 88.8002 229.381C88.6802 229.361 88.3702 229.961 88.0002 229.971C87.3602 229.971 86.8902 227.991 86.5402 228.071C86.3802 228.081 86.2802 228.571 86.2702 228.741Z"
					fill="#8C715D"
				/>
				<path
					d="M40.6099 276.83C39.3999 279.05 38.3199 281.38 37.2799 283.84C33.2899 293 30.6099 302.68 29.3199 312.59C27.8899 315.92 26.4999 319.41 25.1699 323.14C22.3099 331.29 20.1199 339.67 18.6299 348.18L25.1299 349.67L37.5899 315.87C38.2499 314.49 39.1999 312.42 40.3599 309.93C48.7499 291.76 49.5599 288.52 48.5999 285.23C48.0299 283.34 46.3899 279.95 40.6099 276.83Z"
					fill="#FF5630"
				/>
				<path
					d="M93.2998 234.701C92.4698 235.611 90.1798 235.321 88.9798 234.071C88.2798 233.261 87.9498 232.201 88.0498 231.141C88.1298 230.031 88.5798 229.931 88.8698 228.721C89.4798 226.301 88.1698 224.271 88.7298 223.961C88.8598 223.881 89.1298 223.961 89.6698 224.361C89.7598 224.231 89.8998 224.151 90.0598 224.131C90.4298 224.131 90.6898 224.761 90.8198 225.051C91.6298 226.811 92.3198 228.621 92.8898 230.461C93.4498 232.991 93.7198 234.261 93.2998 234.701Z"
					fill="#8C715D"
				/>
				<path
					d="M57.1001 280.58C61.5301 291.23 65.2701 302.16 68.3001 313.29C71.4501 324.83 73.8401 336.57 75.4501 348.42H67.9601C66.8801 343.66 65.6401 338.73 64.2401 333.64C62.3201 326.68 60.2401 320.14 58.1001 313.98C47.5701 303.84 40.5301 295.24 38.4801 290.96C37.6901 289.33 36.2601 286.45 37.2701 283.69C37.4101 283.25 37.8101 282.48 38.5901 280.81C39.3701 279.14 40.0701 277.8 40.5201 276.9C45.8401 278.94 51.4401 280.14 57.1301 280.47L57.1001 280.58Z"
					fill="#FF5630"
				/>
				<path
					d="M66.29 256.611C60.8 256.121 55.57 254.011 51.27 250.551C47.91 247.711 45.24 244.141 43.49 240.101C41.73 236.321 40.72 232.241 40.49 228.091C41.48 222.901 42.35 217.431 43.08 211.671C43.43 208.941 43.72 206.271 43.97 203.651L38.41 200.621C37.2 204.931 36.19 209.511 35.15 214.341C34.04 219.741 33.16 224.921 32.48 229.811C33.17 236.711 35.17 243.411 38.39 249.551C40.28 253.131 42.57 256.491 45.23 259.551C44.47 262.141 43.57 264.901 42.46 267.761C41.11 271.211 39.58 274.591 37.87 277.871C43.32 283.041 50.98 285.181 58.32 283.561C59.25 281.271 60.15 278.801 61.01 276.151C62.11 272.801 63.02 269.391 63.73 265.941C66.67 266.261 69.64 266.181 72.55 265.701C75.66 265.181 80.87 264.311 85.23 260.421C88.86 257.231 90.08 253.551 91.61 249.141C93.34 244.141 94.16 238.871 94.03 233.581C93.33 233.261 92.57 233.111 91.81 233.141C90.79 233.171 89.8 233.511 88.98 234.121C87.69 241.301 84.99 248.161 81.03 254.291C76.52 256.721 71.33 257.571 66.28 256.711L66.29 256.611Z"
					fill="#FF7452"
				/>
				<path
					opacity="0.2"
					d="M305.11 152.641H233.91V227.611H305.11V152.641Z"
					fill="url(#paint16_linear_1375_254)"
				/>
				<path
					d="M238.64 223.24L238.57 221.72L237.95 219.86V216.01C238.03 216 238.11 216 238.18 216.01C238.91 216.29 238.89 217.8 238.89 217.88L238.99 213.76C239.19 213.65 239.48 213.54 239.68 213.66C239.88 213.78 239.89 214.42 239.85 215.17C239.81 215.96 239.81 216.75 239.85 217.54L240.38 213.55C240.55 213.53 240.72 213.57 240.86 213.67C241.04 213.86 241.13 214.12 241.09 214.38C241.09 215.4 240.8 217.39 240.78 217.6L241.98 213.8C242.19 213.85 242.37 213.96 242.5 214.13C242.74 214.47 242.56 214.9 242.2 216.26C241.96 217.18 241.77 217.72 242.06 218.14C242.11 218.21 242.16 218.27 242.23 218.32C242.33 217.73 242.7 217.23 243.24 216.98C243.49 216.89 243.77 216.87 244.03 216.92C243.93 217.11 243.84 217.3 243.74 217.51C243.44 218.14 243.2 218.8 243.01 219.48L242.31 221.37V222.91L238.64 223.24Z"
					fill="#ECC19C"
				/>
				<path
					d="M305.92 152.65C301.71 177.02 290.88 199.77 274.62 218.4H202.62C218.88 199.76 229.7 177.02 233.91 152.65H305.92Z"
					fill="url(#paint17_linear_1375_254)"
				/>
				<path
					d="M295.35 122.201C294.99 121.631 294.55 121.121 294.03 120.691C295.39 120.111 296.42 118.941 296.83 117.521L301.79 100.331C302.74 97.0914 300.87 93.7014 297.63 92.7514C294.39 91.8014 291 93.6714 290.05 96.9114C289.97 97.1814 289.91 97.4513 289.87 97.7213L287.18 115.401C286.96 116.861 287.41 118.351 288.4 119.451C286.13 120.081 284.4 121.921 283.9 124.221C283.15 127.601 285.27 130.941 288.65 131.701L289.23 131.801C292.67 132.251 295.83 129.831 296.29 126.381C296.48 124.921 296.16 123.441 295.37 122.191L295.35 122.201Z"
					fill="white"
				/>
				<path
					d="M294.5 116.84L299.46 99.6499C300.02 97.6899 298.89 95.6399 296.92 95.0699C296.85 95.0499 296.77 95.0299 296.7 95.0099C294.7 94.5799 292.73 95.8399 292.3 97.8399C292.28 97.9199 292.27 97.9899 292.26 98.0699L289.57 115.75C289.37 117.07 290.23 118.32 291.54 118.61C292.84 118.89 294.13 118.12 294.5 116.84Z"
					fill="#0065FF"
				/>
				<path
					d="M286.25 124.732C285.78 126.792 287.07 128.852 289.14 129.322C289.26 129.352 289.39 129.372 289.51 129.392C291.63 129.752 293.64 128.332 294 126.212C294.36 124.092 292.94 122.082 290.82 121.722C288.72 121.302 286.68 122.642 286.25 124.732Z"
					fill="#0065FF"
				/>
				<path
					d="M312.86 122.102C312.7 121.442 312.45 120.822 312.09 120.242C313.57 120.122 314.91 119.352 315.76 118.142L325.99 103.462C327.93 100.702 327.26 96.8818 324.5 94.9418C321.74 93.0018 317.92 93.6718 315.98 96.4318C315.82 96.6618 315.68 96.9018 315.55 97.1418L307.31 113.022C306.63 114.342 306.58 115.882 307.17 117.242C304.82 117.112 302.58 118.292 301.37 120.312C299.58 123.262 300.51 127.112 303.46 128.912L303.97 129.192C307.09 130.722 310.86 129.442 312.39 126.322C313.04 125.002 313.2 123.502 312.86 122.082V122.102Z"
					fill="white"
				/>
				<path
					d="M313.79 116.77L324.02 102.09C325.19 100.41 324.78 98.1104 323.1 96.9404C323.04 96.9004 322.97 96.8504 322.91 96.8104C321.16 95.7604 318.88 96.3204 317.83 98.0704C317.79 98.1304 317.75 98.2004 317.72 98.2704L309.48 114.15C308.86 115.33 309.27 116.79 310.41 117.48C311.55 118.16 313.02 117.85 313.79 116.77Z"
					fill="#253858"
				/>
				<path
					d="M303.43 121.532C302.32 123.332 302.87 125.692 304.67 126.812C304.78 126.882 304.9 126.942 305.02 127.002C306.91 128.032 309.27 127.322 310.3 125.432C311.33 123.542 310.62 121.182 308.73 120.152C306.88 119.082 304.51 119.692 303.43 121.532Z"
					fill="#253858"
				/>
				<path
					d="M229.54 159.601C225.11 159.731 220.86 157.811 218.03 154.401C212.9 147.851 215.22 137.621 223.21 131.581C226.73 128.871 231.04 127.361 235.49 127.301C239.92 127.171 244.17 129.091 247 132.501C252.13 139.051 249.81 149.281 241.82 155.321C238.3 158.041 233.99 159.541 229.54 159.601Z"
					fill="url(#paint18_linear_1375_254)"
				/>
				<path
					d="M229.54 156.381C225.11 156.511 220.86 154.591 218.03 151.181C212.9 144.631 215.22 134.401 223.21 128.361C226.73 125.651 231.04 124.141 235.49 124.081C239.93 123.961 244.18 125.891 247.02 129.311C252.15 135.861 249.83 146.091 241.84 152.131C238.3 154.841 233.99 156.331 229.54 156.381Z"
					fill="white"
				/>
				<path
					d="M240.28 150.121C233.61 155.151 224.72 154.811 220.45 149.351C216.18 143.891 218.1 135.381 224.77 130.331C231.44 125.281 240.33 125.641 244.6 131.101C248.87 136.561 246.94 145.091 240.28 150.121Z"
					fill="#FFC400"
				/>
				<path
					d="M231.38 135.221C230.77 135.771 229.84 135.731 229.27 135.141C228.84 134.461 229.04 133.551 229.73 133.121C230.34 132.571 231.27 132.611 231.84 133.201C232.27 133.881 232.07 134.781 231.38 135.221Z"
					fill="#FF991F"
				/>
				<path
					d="M239.05 144.51C238.44 145.06 237.51 145.02 236.94 144.43C236.51 143.75 236.71 142.84 237.4 142.41C238.01 141.86 238.94 141.9 239.51 142.49C239.94 143.17 239.74 144.07 239.05 144.51Z"
					fill="#FF991F"
				/>
				<path
					d="M226.03 137.57C225.37 139.86 225.83 142.33 227.26 144.24C228.79 146.09 231.09 147.14 233.5 147.1L226.03 137.57Z"
					fill="#FF991F"
				/>
				<path
					d="M417.57 271.881C418.86 274.331 420.12 276.911 421.3 279.661C425.71 289.821 428.66 300.551 430.08 311.541L440.42 351.011L434.66 352.651C431.13 339.801 426.51 327.271 420.86 315.211C420.08 313.601 419.32 311.941 417.79 308.631C408.53 288.481 407.58 284.891 408.65 281.251C409.35 279.091 411.16 275.331 417.57 271.881Z"
					fill="url(#paint19_linear_1375_254)"
				/>
				<path
					d="M360 224.02C360.84 224.93 363.13 224.64 364.32 223.39C365.01 222.58 365.35 221.53 365.25 220.47C365.18 219.36 364.73 219.25 364.43 218.06C363.83 215.63 365.13 213.61 364.57 213.3C364.44 213.22 364.17 213.24 363.63 213.7C363.54 213.57 363.4 213.49 363.24 213.47C362.87 213.47 362.61 214.09 362.5 214.38C361.69 216.15 361 217.97 360.43 219.83C359.86 222.32 359.58 223.58 360 224.02Z"
					fill="#926D5A"
				/>
				<path
					d="M367.04 218.051C367.09 218.721 366.95 219.391 366.64 219.981C366.14 220.971 364.56 224.041 363.54 223.741C363.05 223.601 362.9 222.721 362.88 222.281C362.88 221.421 363.99 220.991 364.11 220.061C364.11 219.851 364.18 219.741 364.22 219.531C364.35 218.991 364.42 218.721 364.54 218.691C364.66 218.661 364.97 219.271 365.34 219.281C365.98 219.281 366.45 217.311 366.78 217.381C366.98 217.391 367.01 217.891 367.04 218.051Z"
					fill="#926D5A"
				/>
				<path
					d="M360.72 216.342C360.46 217.112 360.35 217.932 360.39 218.742C360.23 221.702 359.67 223.522 359.89 223.572C360.11 223.632 360.28 223.012 360.41 222.692C361.52 220.092 363.32 214.592 362.51 214.252C362.11 214.102 361.16 215.242 360.72 216.342Z"
					fill="#926D5A"
				/>
				<path
					d="M399.3 276.031C389.28 300.131 382.44 325.421 378.94 351.291L385.08 351.351C386.34 346.381 388.21 339.301 390.7 330.811C392.66 324.141 393.48 319.421 396.46 313.161C397.69 310.271 399.24 307.531 401.06 304.981C408.13 295.531 415.82 295.731 419.95 287.701C420.66 286.301 422.42 282.871 421.33 279.641C421.16 279.141 420.73 278.241 419.86 276.451C418.99 274.661 418.23 273.121 417.71 272.121C411.82 274.351 405.61 275.671 399.3 276.031Z"
					fill="url(#paint20_linear_1375_254)"
				/>
				<path
					d="M378.84 346.891C378.6 349.141 378.17 351.371 377.56 353.561C376.8 356.301 374.5 358.331 371.69 358.751L366.39 359.541V360.461L374.64 362.451C375.4 362.311 377.53 361.951 377.82 362.611C377.89 362.751 377.89 363.001 377.59 363.411C378.33 363.571 379.1 363.701 379.9 363.821C380.7 363.941 381.47 363.471 381.72 362.711C382.83 359.161 386 349.551 386.17 348.181L378.84 346.891Z"
					fill="#344563"
				/>
				<path
					d="M433.38 349.461C433.77 350.241 434.49 352.311 435.2 354.381C436.21 357.411 435.3 360.751 432.9 362.851L430.07 365.331L430.49 366.061L437.8 363.531C438.31 363.051 439.77 361.731 440.32 362.091C440.44 362.171 440.55 362.361 440.53 362.821C441.53 362.431 442.56 362.001 443.61 361.501L443.87 360.881C443.76 360.561 443.63 360.161 443.48 359.691C442.15 355.511 440.31 348.291 439.66 346.891L433.38 349.461Z"
					fill="#344563"
				/>
				<path
					d="M409.6 193.371L408.64 192.191C407.84 191.211 407.51 189.921 407.74 188.681L407.84 186.021C408.45 185.471 409.02 184.871 409.54 184.231C410.23 183.401 410.51 182.901 410.65 182.951C410.79 183.011 410.83 183.631 410.14 186.281C411.67 185.621 413.16 184.861 414.59 183.991C416.56 182.801 418.17 181.561 419.25 182.071C419.38 182.141 419.82 182.341 419.87 182.711C419.93 183.091 419.37 183.541 419.33 183.581C419.54 183.581 419.85 183.751 419.94 183.981C420.03 184.211 419.55 184.861 419.18 185.171C417.65 186.511 413.79 189.151 412.84 189.791L413.04 191.291L409.6 193.371Z"
					fill="#926D5A"
				/>
				<path
					d="M389.1 249.45C394.78 247.5 400.34 245.24 405.77 242.68L406.54 242.04L406.72 241.88L406.91 241.71C410.32 238.68 413.09 231.86 413.09 231.86C414.58 228.19 415.87 224.43 416.97 220.62C415.77 217.61 414.82 214.51 414.11 211.35C412.71 205.06 412.9 201.08 410.09 195.95C409.42 194.72 408.64 193.56 407.78 192.46L413.23 189.91C415.15 191.98 416.89 194.21 418.43 196.58C422.12 202.26 424.65 208.62 425.87 215.29C426.18 224.39 424.2 233.43 420.11 241.56C418.08 245.55 415.55 249.26 412.57 252.61C412.56 255.02 412.77 257.42 413.2 259.79C414.07 264.45 415.78 268.92 418.25 272.97L397.75 279.52C399.47 275.76 399.42 273.23 398.8 271.75C397.42 268.42 393.74 267.84 392.38 263.85C391.95 262.55 391.82 261.16 392 259.8C389.42 260.03 378.56 260.71 369.09 253.13C355.46 242.22 357.42 224.38 357.56 223.29L364.86 225.02C364.54 228.82 364.94 232.65 366.05 236.3C369.43 246.02 380.36 252.07 389.1 249.45Z"
					fill="url(#paint21_linear_1375_254)"
				/>
				<path
					d="M392.02 232C392.3 232.09 392.59 232.15 392.88 232.19C393.71 232.29 394.51 232.57 395.23 233C396.46 233.86 395.65 235.52 396.72 237.93C397 238.55 397.2 239.2 397.32 239.88C397.38 240.2 397.41 240.52 397.43 240.85C397.43 241.64 397.96 243.24 399.76 246.73L398.65 246.42L395.26 245.12C392.83 243.5 392.28 243.24 392.27 242.09C392.27 240.7 392.27 238.28 392.17 238.19C391.38 237.43 390.36 237.28 391.15 236.34C391.59 235.81 391.94 235.43 392.05 235.32C392.38 234.9 392.63 234.13 392.02 232Z"
					fill="#926D5A"
				/>
				<path
					d="M395.13 232.931C394.76 237.661 395.4 242.421 397 246.891L397.16 247.321C399.05 252.451 404.74 255.071 409.86 253.181C410.4 252.981 410.91 252.741 411.41 252.451L411.94 252.111L412.03 252.041C414.94 250.011 415.65 246.001 413.61 243.091C413.45 242.861 413.27 242.631 413.07 242.421C411.61 240.811 410.37 239.021 409.38 237.091C406.96 232.311 407.29 228.931 404.07 227.091C402 226.091 399.68 225.701 397.4 225.981C396.19 225.981 395.01 226.331 394 226.981C393.22 227.571 392.58 228.331 392.13 229.201C391.65 230.081 391.37 231.061 391.31 232.061C392.62 232.141 393.91 232.471 395.11 233.021L395.13 232.931Z"
					fill="#172B4D"
				/>
				<path
					d="M266.17 222.55L266.68 220.48L268.05 218.12L269.16 212.87C269.05 212.85 268.94 212.85 268.83 212.87C267.72 213.04 267.36 215.09 267.34 215.22L268.35 209.56C268.11 209.36 267.74 209.12 267.44 209.23C267.14 209.34 266.94 210.21 266.8 211.24C266.65 212.33 266.43 213.42 266.16 214.49L266.55 208.93C266.33 208.85 266.09 208.85 265.87 208.93C265.57 209.14 265.38 209.48 265.36 209.84C265.08 211.25 264.9 214.04 264.88 214.29L264.3 208.73C264.01 208.74 263.72 208.85 263.5 209.04C263.08 209.45 263.21 210.07 263.31 212.04C263.38 213.36 263.5 214.16 262.98 214.65C262.9 214.73 262.8 214.8 262.7 214.85C262.74 214.02 262.36 213.23 261.7 212.73C261.37 212.53 260.98 212.42 260.59 212.43C260.67 212.71 260.75 213.01 260.82 213.32C261.05 214.27 261.2 215.24 261.26 216.21L261.69 218.99L261.3 221.1L266.17 222.55Z"
					fill="#F1DAD5"
				/>
				<path
					d="M223.73 247.78H231.6C230.4 244.98 230.1 241.87 230.76 238.89L225.96 238.66C225.9 238.94 225.82 239.35 225.67 239.84C225.6 240.32 225.42 240.78 225.15 241.17C224.61 241.68 223.56 241.38 223.25 241.28L223.73 247.78Z"
					fill="url(#paint22_linear_1375_254)"
				/>
				<path
					d="M242.06 221.301C243.52 228.401 244.04 235.671 243.59 242.911C240.38 246.491 236.39 249.291 231.93 251.091C229.68 252.051 227.27 252.581 224.83 252.661C221.02 252.661 215.86 251.551 215.63 249.581C215.4 247.611 220.15 245.131 223.53 244.211C224.6 243.931 225.7 243.721 226.8 243.591C230.67 242.881 234.34 241.361 237.59 239.141L238.56 222.471L242.06 221.301Z"
					fill="#253858"
				/>
				<path
					d="M221.15 276.251C221.47 274.871 221.98 273.541 222.66 272.291C223.26 272.471 223.86 272.631 224.47 272.751C225.15 272.881 225.68 272.941 225.96 272.971C227.56 273.201 230.62 273.571 238.85 274.191C239.41 274.901 239.92 275.641 240.39 276.411C241.91 278.831 243.01 281.491 243.66 284.271C248.95 305.941 252.92 327.921 255.56 350.071C254.73 351.201 253.64 352.111 252.38 352.721C251.74 352.981 251.77 353.441 250.57 353.561C249.9 350.951 248.83 346.991 247.24 342.231C245.11 335.681 244.04 333.651 243.03 329.671C241.81 324.751 241.34 319.671 241.64 314.611C240.08 311.781 238.47 308.921 236.83 306.031C235.07 302.871 233.36 299.741 231.7 296.631C232.02 301.721 232.22 307.021 232.26 312.521C232.34 323.281 231.82 334.051 230.69 344.751C230.19 345.131 229.6 345.381 228.98 345.471C228.36 345.561 227.72 345.491 227.13 345.271C226.17 345.011 225.31 344.491 224.63 343.761C223.23 334.291 223.1 324.671 224.25 315.161C222.75 310.941 221.63 306.581 220.92 302.161C220.92 302.161 218.39 291.731 219.81 282.401C220.07 280.871 220.88 277.411 221.15 276.251Z"
					fill="#344563"
				/>
				<path
					d="M268.65 358.511L264.2 357.111C259.58 355.651 256.21 351.651 255.58 346.841C255.47 345.981 254.81 342.391 254.54 340.831C253.37 340.591 252.17 340.561 250.99 340.741C249.37 341.011 247.84 341.691 246.54 342.701C247.56 344.981 248.39 347.341 249 349.761C249.63 352.311 250.03 354.921 250.2 357.541C250.27 358.561 250.28 359.411 250.28 359.961H254.67L255.4 359.141L256.51 359.921H267.62L268.65 358.511Z"
					fill="#172B4D"
				/>
				<path
					d="M224.02 338.271C226.42 336.701 229.53 336.701 231.93 338.271C231.67 339.421 231.48 340.581 231.37 341.751C231.14 344.341 231.01 345.821 231.93 346.621C232.7 347.201 233.71 347.371 234.63 347.091L235.19 347.311C232.9 350.101 231.18 352.221 230.14 353.651C229.74 354.241 229.18 354.701 228.53 354.971C227.77 355.311 226.89 355.271 226.17 354.851C225.69 354.491 225.37 353.951 225.28 353.351L224.02 338.271Z"
					fill="#172B4D"
				/>
				<path
					d="M232.7 232.201C233.05 234.221 234.12 236.051 235.71 237.331L234.67 238.441L233.84 243.131C232.78 243.581 231.65 243.861 230.51 243.991C229.01 244.151 227.05 244.361 226.24 243.261C225.82 242.551 225.67 241.711 225.83 240.901C225.88 240.241 225.99 239.591 226.15 238.951C226.55 237.931 227.13 236.991 227.87 236.181C228.64 235.041 229.6 234.041 230.7 233.221C231.32 232.811 231.99 232.461 232.7 232.201Z"
					fill="#ECC19C"
				/>
				<path
					d="M259.84 247.77C253.29 252 246.02 255.01 238.4 256.66C238.81 263.15 240.14 269.55 242.37 275.67C235.67 278.91 227.99 279.49 220.87 277.3C221.04 271.51 220.17 265.73 218.3 260.24C217.36 257.49 216.17 254.84 214.75 252.3C215.78 251.33 216.9 250.45 218.08 249.67C218.08 249.67 218.41 249.45 218.91 249.15C218.91 249.15 219.83 248.59 220.8 248.12C224.83 246.11 232.23 245.42 232.23 245.42C242.31 244.49 241.97 244.66 243.91 244.31C247.56 243.72 251.12 242.72 254.55 241.33L261.59 219.9L267.15 221.36C266.25 225.94 265.1 230.85 263.64 236.01C262.39 240.2 261.16 244.12 259.84 247.77Z"
					fill="#505F79"
				/>
				<path
					d="M217.32 236.312C214.31 241.772 212.22 241.482 211.67 244.772C211.19 247.702 212.2 251.852 215.45 253.592C219.13 255.572 223.16 253.132 223.39 252.992C224.98 251.952 226.21 250.442 226.91 248.672C228.76 244.342 226.07 242.362 228.02 239.132C228.79 237.842 229.56 237.572 232.4 233.882C233.02 233.182 233.41 232.312 233.51 231.382C233.54 230.312 233.18 229.262 232.5 228.432C230.84 226.372 227.91 226.482 227.02 226.532C225.19 226.622 223.42 227.262 221.95 228.362C219.36 230.322 219.59 232.202 217.32 236.312Z"
					fill="#172B4D"
				/>
				<g opacity="0.7">
					<path
						opacity="0.7"
						d="M239.45 173.381L284.65 173.591"
						stroke="#0065FF"
						strokeWidth="2.3634"
						strokeMiterlimit="10"
					/>
					<path
						opacity="0.7"
						d="M236.36 180.891L281.55 181.101"
						stroke="#0065FF"
						strokeWidth="2.3634"
						strokeMiterlimit="10"
					/>
					<path
						opacity="0.7"
						d="M233.48 187.881L268.15 188.041"
						stroke="#0065FF"
						strokeWidth="2.3634"
						strokeMiterlimit="10"
					/>
				</g>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_1375_254"
					x1="127.283"
					y1="172.071"
					x2="534.923"
					y2="172.071"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FAFBFC" />
					<stop offset="0.07" stopColor="#F7F8F9" />
					<stop offset="0.36" stopColor="#EEEFF2" />
					<stop offset="0.8" stopColor="#EBECF0" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1375_254"
					x1="131.217"
					y1="334.842"
					x2="435.36"
					y2="30.71"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F7F8F9" />
					<stop offset="0.7" stopColor="#C1C7D0" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1375_254"
					x1="96.5282"
					y1="344.156"
					x2="419.294"
					y2="21.4012"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0.47" stopColor="#CFD4DB" />
					<stop offset="1" stopColor="#F7F8F9" />
				</linearGradient>
				<linearGradient
					id="paint3_linear_1375_254"
					x1="232.535"
					y1="341.013"
					x2="232.535"
					y2="24.5389"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#EBECF0" />
					<stop offset="0.1" stopColor="#EBECF0" />
					<stop offset="0.8" stopColor="#EBECF0" />
				</linearGradient>
				<linearGradient
					id="paint4_linear_1375_254"
					x1="50.7816"
					y1="355.938"
					x2="400.121"
					y2="6.59805"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0.16" stopColor="#F0F2F5" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint5_linear_1375_254"
					x1="31.8909"
					y1="346.503"
					x2="380.751"
					y2="-2.35706"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0.16" stopColor="#F0F2F5" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint6_linear_1375_254"
					x1="318.272"
					y1="36.6013"
					x2="342.418"
					y2="36.6013"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0.37" stopColor="#E5E8EC" />
					<stop offset="0.52" stopColor="#E5E8EC" stopOpacity="0.99" />
					<stop offset="0.61" stopColor="#E4E7EB" stopOpacity="0.95" />
					<stop offset="0.68" stopColor="#E3E6EA" stopOpacity="0.89" />
					<stop offset="0.74" stopColor="#E1E4E9" stopOpacity="0.81" />
					<stop offset="0.8" stopColor="#DEE2E7" stopOpacity="0.7" />
					<stop offset="0.85" stopColor="#DBDFE5" stopOpacity="0.56" />
					<stop offset="0.91" stopColor="#D8DCE2" stopOpacity="0.4" />
					<stop offset="0.95" stopColor="#D4D8DF" stopOpacity="0.22" />
					<stop offset="1" stopColor="#CFD4DB" stopOpacity="0" />
				</linearGradient>
				<linearGradient
					id="paint7_linear_1375_254"
					x1="216.641"
					y1="36.6013"
					x2="240.787"
					y2="36.6013"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0.37" stopColor="#E5E8EC" />
					<stop offset="0.52" stopColor="#E5E8EC" stopOpacity="0.99" />
					<stop offset="0.61" stopColor="#E4E7EB" stopOpacity="0.95" />
					<stop offset="0.68" stopColor="#E3E6EA" stopOpacity="0.89" />
					<stop offset="0.74" stopColor="#E1E4E9" stopOpacity="0.81" />
					<stop offset="0.8" stopColor="#DEE2E7" stopOpacity="0.7" />
					<stop offset="0.85" stopColor="#DBDFE5" stopOpacity="0.56" />
					<stop offset="0.91" stopColor="#D8DCE2" stopOpacity="0.4" />
					<stop offset="0.95" stopColor="#D4D8DF" stopOpacity="0.22" />
					<stop offset="1" stopColor="#CFD4DB" stopOpacity="0" />
				</linearGradient>
				<linearGradient
					id="paint8_linear_1375_254"
					x1="115.027"
					y1="36.6013"
					x2="139.178"
					y2="36.6013"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0.37" stopColor="#E5E8EC" />
					<stop offset="0.52" stopColor="#E5E8EC" stopOpacity="0.99" />
					<stop offset="0.61" stopColor="#E4E7EB" stopOpacity="0.95" />
					<stop offset="0.68" stopColor="#E3E6EA" stopOpacity="0.89" />
					<stop offset="0.74" stopColor="#E1E4E9" stopOpacity="0.81" />
					<stop offset="0.8" stopColor="#DEE2E7" stopOpacity="0.7" />
					<stop offset="0.85" stopColor="#DBDFE5" stopOpacity="0.56" />
					<stop offset="0.91" stopColor="#D8DCE2" stopOpacity="0.4" />
					<stop offset="0.95" stopColor="#D4D8DF" stopOpacity="0.22" />
					<stop offset="1" stopColor="#CFD4DB" stopOpacity="0" />
				</linearGradient>
				<linearGradient
					id="paint9_linear_1375_254"
					x1="46.5498"
					y1="195.213"
					x2="343.64"
					y2="195.213"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FAFBFC" />
					<stop offset="0.07" stopColor="#F7F8F9" />
					<stop offset="0.36" stopColor="#EEEFF2" />
					<stop offset="0.8" stopColor="#EBECF0" />
				</linearGradient>
				<linearGradient
					id="paint10_linear_1375_254"
					x1="123.802"
					y1="234.803"
					x2="182.51"
					y2="234.803"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#0065FF" />
					<stop offset="1" stopColor="#2684FF" />
				</linearGradient>
				<linearGradient
					id="paint11_linear_1375_254"
					x1="316.721"
					y1="124.824"
					x2="356.442"
					y2="124.824"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#0065FF" />
					<stop offset="1" stopColor="#2684FF" />
				</linearGradient>
				<linearGradient
					id="paint12_linear_1375_254"
					x1="179.368"
					y1="240.263"
					x2="208.086"
					y2="236.093"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FAFBFC" />
					<stop offset="0.07" stopColor="#F7F8F9" />
					<stop offset="0.36" stopColor="#EEEFF2" />
					<stop offset="0.8" stopColor="#EBECF0" />
				</linearGradient>
				<linearGradient
					id="paint13_linear_1375_254"
					x1="306.2"
					y1="172.145"
					x2="326.795"
					y2="192.56"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FAFBFC" />
					<stop offset="0.07" stopColor="#F7F8F9" />
					<stop offset="0.36" stopColor="#EEEFF2" />
					<stop offset="0.8" stopColor="#EBECF0" />
				</linearGradient>
				<linearGradient
					id="paint14_linear_1375_254"
					x1="286.567"
					y1="114.064"
					x2="304.848"
					y2="114.064"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FAFBFC" />
					<stop offset="0.07" stopColor="#F7F8F9" />
					<stop offset="0.36" stopColor="#EEEFF2" />
					<stop offset="0.8" stopColor="#EBECF0" />
				</linearGradient>
				<linearGradient
					id="paint15_linear_1375_254"
					x1="305.397"
					y1="112.221"
					x2="323.225"
					y2="116.301"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FAFBFC" />
					<stop offset="0.07" stopColor="#F7F8F9" />
					<stop offset="0.36" stopColor="#EEEFF2" />
					<stop offset="0.8" stopColor="#EBECF0" />
				</linearGradient>
				<linearGradient
					id="paint16_linear_1375_254"
					x1="269.507"
					y1="227.611"
					x2="269.507"
					y2="152.644"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FAFBFC" stopOpacity="0" />
					<stop offset="0.46" stopColor="#7A869A" />
				</linearGradient>
				<linearGradient
					id="paint17_linear_1375_254"
					x1="254.269"
					y1="218.408"
					x2="254.269"
					y2="152.655"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#0065FF" />
					<stop offset="0.02" stopColor="#0569FF" />
					<stop offset="0.15" stopColor="#1F7BFF" />
					<stop offset="0.3" stopColor="#3389FF" />
					<stop offset="0.46" stopColor="#4192FF" />
					<stop offset="0.66" stopColor="#4A98FF" />
					<stop offset="1" stopColor="#4C9AFF" />
				</linearGradient>
				<linearGradient
					id="paint18_linear_1375_254"
					x1="215.295"
					y1="143.453"
					x2="249.73"
					y2="143.453"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FAFBFC" />
					<stop offset="0.12" stopColor="#EBECEF" />
					<stop offset="0.26" stopColor="#E2E4E7" />
					<stop offset="0.46" stopColor="#DFE1E5" />
				</linearGradient>
				<linearGradient
					id="paint19_linear_1375_254"
					x1="419.513"
					y1="295.016"
					x2="434.695"
					y2="334.395"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0.25" stopColor="#0065FF" />
					<stop offset="0.37" stopColor="#0065FF" />
					<stop offset="0.76" stopColor="#4C9AFF" />
				</linearGradient>
				<linearGradient
					id="paint20_linear_1375_254"
					x1="400.309"
					y1="351.338"
					x2="400.309"
					y2="272.103"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#4C9AFF" />
					<stop offset="1" stopColor="#0065FF" />
				</linearGradient>
				<linearGradient
					id="paint21_linear_1375_254"
					x1="391.632"
					y1="279.526"
					x2="391.632"
					y2="189.922"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#B2D4FF" />
					<stop offset="1" stopColor="#2684FF" />
				</linearGradient>
				<linearGradient
					id="paint22_linear_1375_254"
					x1="231.595"
					y1="243.221"
					x2="223.248"
					y2="243.221"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0.38" stopColor="#F1DBCB" />
					<stop offset="1" stopColor="#EFC7B0" />
				</linearGradient>
				<clipPath id="clip0_1375_254">
					<rect width="569.18" height="371.12" fill="white" transform="translate(0 0.380859)" />
				</clipPath>
			</defs>
		</svg>
	);
};

export { EmptyImage };
